(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BA-accessories-section"] && !Shopify.designMode) return;
  try {
    

const btnsEl = document.querySelectorAll('.play-img');
const modal = document.querySelector('#accessories-section .dynamicVideoModal');
let videoUrl = "";
let modelFrame = modal.querySelector('iframe');
  if(btnsEl.length > 0) {
    btnsEl.forEach((btnEle) => {
      btnEle.addEventListener('click', function() {
        videoUrl = btnEle.parentElement.getAttribute('video-url');
        modelFrame.setAttribute('src', videoUrl);
      });
      btnEle.parentElement.addEventListener('click', function() {
        videoUrl = btnEle.parentElement.getAttribute('video-url');
        modelFrame.setAttribute('src', videoUrl);
      });
    });
}
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BA-text-with-image-slider"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  const logoSwiper = new Swiper('.Phototherapy.lprp-swiper', {
    slidesPerView: 5,
    spaceBetween: 10,
    loop: false,
    allowTouchMove: false,     // default: no swipe/drag
    simulateTouch: false,      // default: no mouse drag

    // navigation arrows always available
    navigation: {
      nextEl: '.arrow-next.swiper-button-next',
      prevEl: '.arrow-prev.swiper-button-prev',
    },

    breakpoints: {
      // <1024px (mobile/tablet): slider active
      0: {
        slidesPerView: 2.2,
        spaceBetween: 20,
        allowTouchMove: true,
        simulateTouch: true,
      },
      320: {
        slidesPerView: 2.2,
        spaceBetween: 20,
        allowTouchMove: true,
        simulateTouch: true,
      },
      390: {
        slidesPerView: 2.2,
        spaceBetween: 20,
        allowTouchMove: true,
        simulateTouch: true,
      },
      576: {
        slidesPerView: 2.5,
        spaceBetween: 20,
        allowTouchMove: true,
        simulateTouch: true,
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 20,
        allowTouchMove: true,
        simulateTouch: true,
      },
      
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
        allowTouchMove: true,
        simulateTouch: true,
      },
      // ≥1025px: no slider (drag/swipe disabled)
      1025: {
        slidesPerView: 5,
        spaceBetween: 10,
        allowTouchMove: false,
        simulateTouch: false,
      }
    },
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BA-warranty-section"] && !Shopify.designMode) return;
  try {
    

const btnsEl = document.querySelectorAll('.play-img');
const modal = document.querySelector('#warranty-section .dynamicVideoModal');
let videoUrl = "";
let modelFrame = modal.querySelector('iframe');
  if(btnsEl.length > 0) {
    btnsEl.forEach((btnEle) => {
      btnEle.addEventListener('click', function() {
        videoUrl = btnEle.parentElement.getAttribute('video-url');
        modelFrame.setAttribute('src', videoUrl);
      });
      btnEle.parentElement.addEventListener('click', function() {
        videoUrl = btnEle.parentElement.getAttribute('video-url');
        modelFrame.setAttribute('src', videoUrl);
      });
    });
}
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["GMH-physician-section"] && !Shopify.designMode) return;
  try {
    
  const cards = document.querySelectorAll('.review-card');
if (cards.length > 0) {
  cards.forEach((card) => {
    const btn = card.querySelector('.ExpandBtn');
    if (btn) {
      btn.addEventListener('click', function () {
        const short = card.querySelector('.short');
        const long = card.querySelector('.long');
        
        if (short.style.display === "none") {
          // Currently showing the long description, switch to short description
          short.style.display = "block";
          long.style.display = "none";
          btn.textContent = "Read More";
        } else {
          // Currently showing the short description, switch to long description
          short.style.display = "none";
          long.style.display = "block";
          btn.textContent = "Read Less";
        }
      });
    }
  });
}
  
const btnsEl = document.querySelectorAll('.play-img');
const modal = document.querySelector(' .physician-slider  .dynamicVideoModal');
let videoUrl = "";
let modelFrame = modal.querySelector('iframe');
if(btnsEl.length > 0) {
  btnsEl.forEach((btnEle) => {
    btnEle.addEventListener('click', function() {
      videoUrl = btnEle.parentElement.getAttribute('video-url');
      modelFrame.setAttribute('src', videoUrl);
    });
    btnEle.parentElement.addEventListener('click', function() {
      videoUrl = btnEle.parentElement.getAttribute('video-url');
      modelFrame.setAttribute('src', videoUrl);
    });
  });
}

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["GMH-real-result-slider"] && !Shopify.designMode) return;
  try {
    
  const cards = document.querySelectorAll('.review-card');
if (cards.length > 0) {
  cards.forEach((card) => {
    const btn = card.querySelector('.ExpandBtn');
    if (btn) {
      btn.addEventListener('click', function () {
        const short = card.querySelector('.short');
        const long = card.querySelector('.long');
        
        if (short.style.display === "none") {
          // Currently showing the long description, switch to short description
          short.style.display = "block";
          long.style.display = "none";
          btn.textContent = "Read More";
        } else {
          // Currently showing the short description, switch to long description
          short.style.display = "none";
          long.style.display = "block";
          btn.textContent = "Read Less";
        }
      });
    }
  });
}
  
const btnsEl = document.querySelectorAll('.play-img');
const modal = document.querySelector('.cust-review-section .dynamicVideoModal');
let videoUrl = "";
let modelFrame = modal.querySelector('iframe');
if(btnsEl.length > 0) {
  btnsEl.forEach((btnEle) => {
    btnEle.addEventListener('click', function() {
      videoUrl = btnEle.parentElement.getAttribute('video-url');
      modelFrame.setAttribute('src', videoUrl);
    });
    btnEle.parentElement.addEventListener('click', function() {
      videoUrl = btnEle.parentElement.getAttribute('video-url');
      modelFrame.setAttribute('src', videoUrl);
    });
  });
}

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["NewHomepage_theradome-leads"] && !Shopify.designMode) return;
  try {
    
  const cards = document.querySelectorAll('.review-card');
if (cards.length > 0) {
  cards.forEach((card) => {
    const btn = card.querySelector('.ExpandBtn');
    if (btn) {
      btn.addEventListener('click', function () {
        const short = card.querySelector('.short');
        const long = card.querySelector('.long');
        
        if (short.style.display === "none") {
          // Currently showing the long description, switch to short description
          short.style.display = "block";
          long.style.display = "none";
          btn.textContent = "Read More";
        } else {
          // Currently showing the short description, switch to long description
          short.style.display = "none";
          long.style.display = "block";
          btn.textContent = "Read Less";
        }
      });
    }
  });
}
  


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Newhome-GMH-slider"] && !Shopify.designMode) return;
  try {
    
  const cards = document.querySelectorAll('.review-card');
if (cards.length > 0) {
  cards.forEach((card) => {
    const btn = card.querySelector('.ExpandBtn');
    if (btn) {
      btn.addEventListener('click', function () {
        const short = card.querySelector('.short');
        const long = card.querySelector('.long');
        
        if (short.style.display === "none") {
          // Currently showing the long description, switch to short description
          short.style.display = "block";
          long.style.display = "none";
          btn.textContent = "Read More";
        } else {
          // Currently showing the short description, switch to long description
          short.style.display = "none";
          long.style.display = "block";
          btn.textContent = "Read Less";
        }
      });
    }
  });
}
  
const btnsEl = document.querySelectorAll('.play-img');
const modal = document.querySelector(' .physician-slider  .dynamicVideoModal');
let videoUrl = "";
let modelFrame = modal.querySelector('iframe');
if(btnsEl.length > 0) {
  btnsEl.forEach((btnEle) => {
    btnEle.addEventListener('click', function() {
      videoUrl = btnEle.parentElement.getAttribute('video-url');
      modelFrame.setAttribute('src', videoUrl);
    });
    btnEle.parentElement.addEventListener('click', function() {
      videoUrl = btnEle.parentElement.getAttribute('video-url');
      modelFrame.setAttribute('src', videoUrl);
    });
  });
}

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["PDP-add"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const addToCartButton = document.querySelector('.add-to-cart .btn-add-to-cart');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', function (e) {
        e.preventDefault();
        const link = document.querySelector('.drtv-hel a');
        if (link) {
          link.click();
        }
      });
    }
  });
  document.addEventListener('scroll', () => {
    const faqSection = document.querySelector('.homepage-see-why-theradome-leads');
    //const faqSection = document.querySelector('.helmet-feature-slider');
    const header = document.querySelector('.header-wrapper');
    const addToCart = document.querySelector('.pdp-add-to-cart');

    if (!faqSection || !header || !addToCart) return;

    const headerHeight = header.offsetHeight;
    const faqRect = faqSection.getBoundingClientRect();

    if (faqRect.top - headerHeight * 2.5 <= 0) {
      console.log('sticky');
      addToCart.classList.add('sticky');
    } else {
      addToCart.classList.remove('sticky');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["PQ_GMH-physician-slider"] && !Shopify.designMode) return;
  try {
    
  const cards = document.querySelectorAll('.review-card');
if (cards.length > 0) {
  cards.forEach((card) => {
    const btn = card.querySelector('.ExpandBtn');
    if (btn) {
      btn.addEventListener('click', function () {
        const short = card.querySelector('.short');
        const long = card.querySelector('.long');
        
        if (short.style.display === "none") {
          // Currently showing the long description, switch to short description
          short.style.display = "block";
          long.style.display = "none";
          btn.textContent = "Read More";
        } else {
          // Currently showing the short description, switch to long description
          short.style.display = "none";
          long.style.display = "block";
          btn.textContent = "Read Less";
        }
      });
    }
  });
}
  
const btnsEl = document.querySelectorAll('.play-img');
const modal = document.querySelector(' .physician-slider  .dynamicVideoModal');
let videoUrl = "";
let modelFrame = modal.querySelector('iframe');
if(btnsEl.length > 0) {
  btnsEl.forEach((btnEle) => {
    btnEle.addEventListener('click', function() {
      videoUrl = btnEle.parentElement.getAttribute('video-url');
      modelFrame.setAttribute('src', videoUrl);
    });
    btnEle.parentElement.addEventListener('click', function() {
      videoUrl = btnEle.parentElement.getAttribute('video-url');
      modelFrame.setAttribute('src', videoUrl);
    });
  });
}

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cms-policy"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
  const buttons = document.querySelectorAll(".lang-btn");
  const contents = document.querySelectorAll(".lang-content");
  const englishTitle = document.querySelector(".english-title");
  const frenchTitle = document.querySelector(".french-title");

  englishTitle.classList.add("active");

  buttons.forEach(btn => {
    btn.addEventListener("click", () => {
      const selectedLang = btn.dataset.lang;

      buttons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      contents.forEach(content => {
        if (content.classList.contains(selectedLang + "-content")) {
          content.classList.add("active");
        } else {
          content.classList.remove("active");
        }
      });

      if (selectedLang === "english") {
        englishTitle.classList.add("active");
        frenchTitle.classList.remove("active");
      } else {
        frenchTitle.classList.add("active");
        englishTitle.classList.remove("active");
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-review-section"] && !Shopify.designMode) return;
  try {
    
  const cards = document.querySelectorAll('.review-card');
if (cards.length > 0) {
  cards.forEach((card) => {
    const btn = card.querySelector('.ExpandBtn');
    if (btn) {
      btn.addEventListener('click', function () {
        const short = card.querySelector('.short');
        const long = card.querySelector('.long');
        
        if (short.style.display === "none") {
          // Currently showing the long description, switch to short description
          short.style.display = "block";
          long.style.display = "none";
          btn.textContent = "Read More";
        } else {
          // Currently showing the short description, switch to long description
          short.style.display = "none";
          long.style.display = "block";
          btn.textContent = "Read Less";
        }
      });
    }
  });
}
  
const btnsEl = document.querySelectorAll('.play-img');
const modal = document.querySelector('.collection-review-section .dynamicVideoModal');
let videoUrl = "";
let modelFrame = modal.querySelector('iframe');
if(btnsEl.length > 0) {
  btnsEl.forEach((btnEle) => {
    btnEle.addEventListener('click', function() {
      videoUrl = btnEle.parentElement.getAttribute('video-url');
      modelFrame.setAttribute('src', videoUrl);
    });
    btnEle.parentElement.addEventListener('click', function() {
      videoUrl = btnEle.parentElement.getAttribute('video-url');
      modelFrame.setAttribute('src', videoUrl);
    });
  });
}

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-quiz-result"] && !Shopify.designMode) return;
  try {
    

$(".user-quiz-result-page .accordion").click(function(){
   
        //alert("ddd");
        const accordionContent = $(this).children(".accordion-content");
        const accordionIcon = $(this).children('.accordion-icon');
         this.classList.toggle('active');
         $(this).removeClass('in-active');
         if (accordionContent.css("display") == "block" ){
            accordionContent.hide();
            accordionIcon.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/plus.svg?v=1686302656)';
         } else {
            accordionContent.show
            accordionIcon.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/minus.png?v=1685959923)';
         }
});



 let searchParams = new URLSearchParams(window.location.search);
  let user_id = searchParams.get('user_id');

  //console.log(user_id);
  if (user_id) {
    var post_data = {
        user_info_id: user_id,
        operation: "get_resuts_by_user_id_frontend"
    };

    $.ajax({
        type: "POST",
        url: "/apps/quizInformation",//quizInfo
        data: post_data,
        crossDomain: true,
        success: function(data) {
            console.log(data,"data");
            var targetMaindiv = $(".quiz-result-data");
            targetMaindiv.empty();

            var userMaindiv = $(".user-info-data");
            userMaindiv.empty();

            var imgData='-'; 
            var responseDataJson = data;
            var responseDataJsonParse = JSON.parse(responseDataJson);
            var user_selection = responseDataJsonParse.user_selection;
            var userinfoData = responseDataJsonParse.user_info;

            var image_option_path = responseDataJsonParse.image_option_path;
            var image_user_path = responseDataJsonParse.image_user_path;

        
            //console.log(userinfoData);
            var i=1;
            for (var key in user_selection) {
            if (user_selection.hasOwnProperty(key)) {
                var value = user_selection[key];
                //console.log(key+"  "+value);

                var option_text_item_data = value.option_text_item;

                var option_image_item_data = value.option_image_item;

                var option_summery_item_data = value.option_summery_item;


                //console.log(option_summery_item_data);

                if(option_text_item_data.length == 1){

                    sammaryhtml = "";
                    for (var sammry_key in option_summery_item_data) {
                    if (option_summery_item_data.hasOwnProperty(sammry_key)) {
                        var samary_value = option_summery_item_data[sammry_key];
                        //console.log(samary_value);
                        samary_value = JSON.parse(samary_value);
                        //console.log(samary_value);
                        //console.log(sammry_key+"  "+value);
                        var sammaryhtml = sammaryhtml + '<div><p>' +samary_value+ '</p></div>'

                    }}
                }else{
                        
                    sammaryhtml = "";
                for (var sammry_key in option_summery_item_data) {
                    if (option_summery_item_data.hasOwnProperty(sammry_key)) {
                        var samary_value = option_summery_item_data[sammry_key];
                        samary_value = JSON.parse(samary_value);
                        //console.log(sammry_key+"  "+value);
                        var sammaryhtml = sammaryhtml + '<div><b>' + sammry_key + '</b><p>' +samary_value+ '</p></div>'

                    }}
                }

                //console.log(sammaryhtml);

                //console.log(option_image_item_data);
              
                if(option_image_item_data !== 'undefined' && option_image_item_data.length > 0){
                    imgData = '<img src=' + image_option_path + '' + option_image_item_data + '>';
                }else{
                  imgData = '<img>';
                }

             targetMaindiv.append('<div class="accordion  in-active"><div class="container"><div class="accordion-header"><div class="desktop-view"><div class="questionss"><h3><span>' + i + '</span>' + key + ' </h3></div><div class="response">' + imgData + '<h4>' + option_text_item_data + '</h4></div><span class="accordion-icon" style="background-image: url(&quot;https://cdn.shopify.com/s/files/1/0721/6024/8100/files/plus.png?v=1685959923&quot;);"></span></div><div class="mobile-view"><h3 class="mobile-view-detail">Click (+) to Expand</h3></div></div><div class="accordion-content" style="display:none;">' +sammaryhtml+ '</div></div></div>');

            }
            i++;
        }


             var user_name = userinfoData[0].user_name;
             var user_email = userinfoData[0].user_email;
             var user_image = userinfoData[0].user_image;
             if(user_image != "No Image" && user_image != "Maybe later"){
                userimageData = '<img width="80px" height="80px" src=' + image_user_path + '' + user_image + '>';
             }else{
                  userimageData = '<img>';
            }

            var user_image_count = i;
            var user_name_count = i +1;
            var user_email_count = i +2;


            userMaindiv.append('<div class="accordion  in-active"><div class="container"><div class="accordion-header"><div class="desktop-view"><div class="questionss"><h3><span>' + user_image_count + '</span>Get your scalp analyzed</h3></div><div class="response">'+ userimageData + '</div></div><div class="mobile-view"></div></div></div></div><div class="accordion  in-active"><div class="container"><div class="accordion-header"><div class="desktop-view"><div class="questionss"><h3><span>' + user_name_count + '</span>What is your first name?</h3></div><div class="response"><h4>' + user_name + '</h4></div></div><div class="mobile-view"></div></div></div></div><div class="accordion  in-active"><div class="container"><div class="accordion-header"><div class="desktop-view"><div class="questionss"><h3><span>' + user_email_count + '</span>What is your email address?</h3></div><div class="response"><h4>' + user_email + '</h4></div></div><div class="mobile-view"></div></div></div></div>');


        }
    });

}


$(document).on('click', '.accordion', function () {
      $(this).toggleClass('active');
      $(this).toggleClass('in-active');
      var content_text = $(this).find('.accordion-content').text();
      if(!content_text){
        $(".active .accordion-icon").css({"background-image": "url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/plus.png?v=1685959923)"}); 
        $(this).find('.accordion-content').remove();
      }else{
        $(".active .accordion-icon").css({"background-image": "url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/minus.png?v=1685959923)"});  
         $(".in-active .accordion-icon").css({"background-image": "url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/plus.png?v=1685959923)"}); 
      }
   });

       // Get all the accordion elements
   const accordions = document.getElementsByClassName('accordion');

   // Add click event listener to each accordion
   for (let i = 0; i < accordions.length; i++) {
      const accordion = accordions[i];
      const accordionContent = accordion.querySelector('.accordion-content');
      const accordionIcon = accordion.querySelector('.accordion-icon');

      // Open accordion by default
     // accordion.classList.add('active');
    //  accordionContent.style.display = 'block';
    //  accordionIcon.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/minus.png?v=1685959923)';
 // Open only the first accordion by default
    if (i === 0) {
      accordion.classList.add('active');
      accordionContent.style.display = 'block';
      accordionIcon.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/minus.png?v=1685959923)';
    } else {
        accordion.classList.add('in-active');
      accordionContent.style.display = 'none';
      accordionIcon.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/plus.png?v=1685959923)';
    }
      accordion.addEventListener('click', function () {
         this.classList.toggle('active');

         if (accordionContent.style.display === 'block') {
            accordionContent.style.display = 'none';
            accordionIcon.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/plus.svg?v=1686302656)';
         } else {
            accordionContent.style.display = 'block';
            accordionIcon.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/minus.png?v=1685959923)';
         }
      });
   }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
   class LocalizationForm extends HTMLElement {
     constructor() {
       super();
       this.elements = {
         input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
         button: this.querySelector('button'),
         panel: this.querySelector('.disclosure__list-wrapper'),
       };
       this.elements.button.addEventListener('click', this.openSelector.bind(this));
       this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
       this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
 
       this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
     }
 
     hidePanel() {
       this.elements.button.setAttribute('aria-expanded', 'false');
       this.elements.panel.setAttribute('hidden', true);
     }
 
     onContainerKeyUp(event) {
       if (event.code.toUpperCase() !== 'ESCAPE') return;
 
       this.hidePanel();
       this.elements.button.focus();
     }
 
     onItemClick(event) {
       event.preventDefault();
       const form = this.querySelector('form');
       this.elements.input.value = event.currentTarget.dataset.value;
       if (form) form.submit();
     }
 
     openSelector() {
       this.elements.button.focus();
       this.elements.panel.toggleAttribute('hidden');
       this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
     }
 
     closeSelector(event) {
       const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
       if (event.relatedTarget === null || shouldClose) {
         this.hidePanel();
       }
     }
   }
 
   customElements.define('localization-form', LocalizationForm);
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-original"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-quiz-MBG"] && !Shopify.designMode) return;
  try {
    
(function () {
  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? decodeURIComponent(match[2]) : null;
  }

  const quizStatus = getCookie("quiz_status");
  const quizResultUrl = getCookie("quiz_result_url");

  if (quizStatus === "complete") {
    const banner = document.querySelector(".pdp-mbg-banner");

    if (!banner) return;

    let shouldShowBanner = true; // Default to showing the banner

    if (quizResultUrl) {
      if (quizResultUrl.includes("pro-recommendation")) {
        // Only show if body has the Pro class
        if (!document.body.classList.contains("product-theradome-pro-lh80")) {
          shouldShowBanner = false;
        }
      } else if (quizResultUrl.includes("evo")) {
        // Only show if body has the Evo class
        if (!document.body.classList.contains("product-theradome-evo-lh40")) {
          shouldShowBanner = false;
        }
      }
    }

    if (shouldShowBanner) {
      banner.style.display = "block";

      const linkEl = document.querySelector(".pdp-mbg-banner .mbg-subtext p a");
      const textEl = document.querySelector(".pdp-mbg-banner .mbg-subtext p");

      if (linkEl) {
        if (quizResultUrl) {
          linkEl.href = quizResultUrl;
        } else {
          if (textEl) {
            const tooltipSpan = textEl.querySelector(".tooltip-wrapper");
            let savedTooltip = null;
            if (tooltipSpan) {
              savedTooltip = tooltipSpan.cloneNode(true);
              tooltipSpan.remove();
            }
            textEl.innerHTML = `Get this offer by entering the code MBG12MO200 at checkout. `;
            if (savedTooltip) {
              textEl.appendChild(savedTooltip);
            }
          }
        }
      }
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-customized-report"] && !Shopify.designMode) return;
  try {
    


$(".user-quiz-result-page .accordion").click(function(){
   
        const accordionContent = $(this).children(".accordion-content");
        const accordionIcon = $(this).children('.accordion-icon');
         this.classList.toggle('active');
         $(this).removeClass('in-active');
         if (accordionContent.css("display") == "block" ){
            accordionContent.hide();
            accordionIcon.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/plus.svg?v=1686302656)';
         } else {
            accordionContent.show
            accordionIcon.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/minus-icon-pq.png?v=1727102553)';
         }
});

// Decoding (for retrieving from URL)
function decodeUserId(encodedUserId) {
    return atob(encodedUserId); // atob() decodes the base64 string
}

  function fixBrokenApostrophes(str) {
    return str.replace(/â€™/g, "'");
  }


 let searchParams = new URLSearchParams(window.location.search);
  let user_id = searchParams.get('user_id');

  //console.log(user_id);
  if (user_id) {
     var decodeUid = decodeUserId(user_id); 
    var post_data = {
        user_info_id: decodeUid,
        operation: "get_resuts_by_user_id_frontend"
    };
    // Show the loader before making the AJAX request
    $(".report-gif-sec").show();
    $.ajax({
        type: "POST",
        url: "/apps/v3quizInformation",
        data: post_data,
        crossDomain: true,
        success: function(data) {
          //  console.log(data);
           // Show the loader before making the AJAX request
          $(".report-gif-sec").hide();
            var targetMaindiv = $(".quiz-result-data");
            targetMaindiv.empty();

            var userMaindiv = $(".user-info-data");
            userMaindiv.empty();

            var imgData='-'; 
            var responseDataJson = data;
            var responseDataJsonParse = JSON.parse(responseDataJson);
            var user_selection = responseDataJsonParse.user_selection;
            var userinfoData = responseDataJsonParse.user_info;

            var image_option_path = responseDataJsonParse.image_option_path;
            var image_user_path = responseDataJsonParse.image_user_path;

          var i = 1; // Initial index
          var last_response_value = ""; // Variable to store the last response value
          var suffixCounter = 0; // Counter for the letter suffix (a, b, c, ...)
          // Function to append accordion with view more functionality
        for (var key in user_selection) {
            if (user_selection.hasOwnProperty(key)) {
                var value = user_selection[key];
                var option_summery_item_data = value.option_summery_item;

        // Build the summary HTML with limit
        var sammaryhtml = "";
        var sammaryFullHtml = "";
        var characterLimit = 275; // Character limit for displaying summary initially

        for (var sammry_key in option_summery_item_data) {
            if (option_summery_item_data.hasOwnProperty(sammry_key)) {
                var samary_value = option_summery_item_data[sammry_key];
                
                // Parse only if necessary
                if (typeof samary_value === 'string') {
                    try {
                        samary_value = fixBrokenApostrophes(JSON.parse(samary_value));
                        console.log('samary_value', samary_value)
                    } catch (e) {
                        
                    }
                }

                // Append full content to sammaryFullHtml
                samary_value = fixBrokenApostrophes(samary_value);
              
                sammaryFullHtml += '<div><p>' + samary_value + '</p></div>';

                // Limit the characters for sammaryhtml if it exceeds the character limit
                if (sammaryhtml.length < characterLimit) {
                    if ((sammaryhtml.length + samary_value.length) > characterLimit) {
                        sammaryhtml += samary_value.substring(0, characterLimit - sammaryhtml.length) + '...'; 
                    } else {
                        sammaryhtml += samary_value;
                    }
                }
            }
        }

// Handling option_response_item as key-value pairs
var option_response_html = "";
var suffixCounter = 0; // Reset suffix for each new 'i'
var last_response_value = ""; // Ensure we track the last response value
if (value.option_response_item && typeof value.option_response_item === 'object') {
    var responseKeys = Object.keys(value.option_response_item);
    var responseCount = responseKeys.length; // Get the count of responses

    for (var response_key in value.option_response_item) {
        if (value.option_response_item.hasOwnProperty(response_key)) {
            var response_value = value.option_response_item[response_key];
            
            // Remove any surrounding quotes from the response_value string
            if (typeof response_value === 'string') {
                response_value = response_value.replace(/^"(.*)"$/, '$1');
            }

            // Only add a new h3 if the current response_value is different from the last one
            if (response_value !== last_response_value) {
                var indexDisplay = i; // Base number

                // If there are multiple responses, add the suffix (i, ii, etc.)
                if (responseCount > 1) {
                    if (suffixCounter === 0) {
                        // First item should show as the base index (e.g., '4')
                        indexDisplay = i;
                    } else {
                        // Subsequent items should use roman numerals (i, ii, etc.)
                        var romanNumerals = ['(i)', '(ii)', '(iii)', '(iv)', '(v)', '(vi)', '(vii)', '(viii)', '(ix)', '(x)'];
                        indexDisplay = romanNumerals[suffixCounter - 1] || suffixCounter; // Handle larger suffixes if needed
                    }
                }

                // Create the response title
                option_response_html += '<h3><span>' + indexDisplay + '</span> ' + response_value + '</h3>';
                last_response_value = response_value; // Update the last response value
                suffixCounter++; // Increment the suffix counter for the next response
            }
        }
    }
}

        // Append the summary and response HTML to the accordion
        var accordionHTML = 
            '<div class="accordion in-active">' +
            '<div class="accordion-header">' +
            '<div class="desktop-view">' +
            '<div class="questionss">' + option_response_html + '</div>' +
            '<span class="accordion-icon" style="background-image: url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/plus-icon-pq.png?v=1727102839);"></span>' +
            '</div>' +
            '</div>' +
            '<div class="accordion-content" style="display:none;">' + 
            '<div class="summary-short">' + sammaryhtml + '</div>' + 
            '<div class="summary-full" style="display:none;">' + sammaryFullHtml + '</div>' + 
            '<div class="accordionpq-btn view-more-btn"> View more </div>' + 
            '</div>' +
            '</div>';

        targetMaindiv.append(accordionHTML);
        
        i++; // Increment index after adding the first title with the index
    }
}
   /*var user_name = userinfoData[0].user_name;
             var user_email = userinfoData[0].user_email;
             var user_image = userinfoData[0].user_image;
             if(user_image != "No Image" && user_image != "Maybe later"){
                userimageData = '<img width="80px" height="80px" src=' + image_user_path + '' + user_image + '>';
             }else{
                  userimageData = '<img>';
            }

            var user_image_count = i;
            var user_name_count = i +1;
            var user_email_count = i +2;


           userMaindiv.append('<div class="accordion  in-active"><div class="container"><div class="accordion-header"><div class="desktop-view"><div class="questionss"><h3><span>' + user_image_count + '</span>Get your scalp analyzed</h3></div><div class="response">'+ userimageData + '</div></div><div class="mobile-view"></div></div></div></div><div class="accordion  in-active"><div class="container"><div class="accordion-header"><div class="desktop-view"><div class="questionss"><h3><span>' + user_name_count + '</span>What is your first name?</h3></div><div class="response"><h4>' + user_name + '</h4></div></div><div class="mobile-view"></div></div></div></div><div class="accordion  in-active"><div class="container"><div class="accordion-header"><div class="desktop-view"><div class="questionss"><h3><span>' + user_email_count + '</span>What is your email address?</h3></div><div class="response"><h4>' + user_email + '</h4></div></div><div class="mobile-view"></div></div></div></div>');
*/

        /*PDF code start */

   $('#download-pdf-btn').on('click', async function() {
    const { jsPDF } = window.jspdf;
    const pdf = new jsPDF();
    let yOffset = 40; // Adjusted to leave space for logo and links
    const margin = 10;
    const pageWidth = pdf.internal.pageSize.width - 2 * margin;
    const pageHeight = pdf.internal.pageSize.height - 20;

    // Logo URL and dimensions
    const logoUrl = "https://theradome.com/cdn/shop/files/theradome-logo-min.png?v=1683205621&width=500";
    const imgWidth = 50; // Adjust width as needed
    const imgHeight = 15; // Adjust height as needed
    const imgX = (pdf.internal.pageSize.width - imgWidth) / 2; // Centering the logo horizontally

    // Fetch and convert the logo to a data URL asynchronously
    async function getImageDataUrl(url) {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }

    // Get the logo data URL and add it to the PDF
    const imageDataUrl = await getImageDataUrl(logoUrl);
    pdf.addImage(imageDataUrl, 'PNG', imgX, 10, imgWidth, imgHeight);

    // Add a link to the logo that redirects to the home page
    pdf.setTextColor(0, 0, 255); // Link color (blue)
    const logoLinkX = imgX; // X position of the logo
    const logoLinkY = 10; // Y position of the logo
    const logoLinkWidth = imgWidth; // Width of the clickable area (same as logo width)
    const logoLinkHeight = imgHeight; // Height of the clickable area (same as logo height)
    pdf.link(logoLinkX, logoLinkY, logoLinkWidth, logoLinkHeight, { url: 'https://theradome.com/' });

    // Get the full current URL
    const currentUrl = window.location.href;
  
    // Add "Back" link on the right (blue color for the link)
    const backX = pdf.internal.pageSize.width - margin - pdf.getTextWidth('Back');
    pdf.setFontSize(14).setTextColor(0, 0, 255).textWithLink(
        'Back',
        backX,
        20,
        { url: currentUrl }
    );

    // Set the regular text color (black in this case)
    pdf.setTextColor(0, 0, 0); // Black color for normal text

    // Add the title and continue with the PDF content
    pdf.setFontSize(18).text("Theradome Hair Quiz Report", margin, yOffset);
    yOffset += 15;

    var i = 1; // Initial index
    var suffixCounter = 0; // Counter for the letter suffix (a, b, c, ...)
    var last_response_value = ""; // Variable to store the last response value
    
    var responseDataJson = data;
    var responseDataJsonParse = JSON.parse(responseDataJson);
    var user_selection = responseDataJsonParse.user_selection;
    
    for (var key in user_selection) {
        if (user_selection.hasOwnProperty(key)) {
            var value = user_selection[key];
            var option_summery_item_data = value.option_summery_item;

            // Build the summary HTML with limit
            var sammaryhtml = "";
            var sammaryFullHtml = "";
            var characterLimit = 275; // Character limit for displaying summary initially
            
            for (var sammry_key in option_summery_item_data) {
                if (option_summery_item_data.hasOwnProperty(sammry_key)) {
                    var samary_value = option_summery_item_data[sammry_key];
                    
                    // Parse only if necessary
                    if (typeof samary_value === 'string') {
                        try {
                            samary_value = JSON.parse(samary_value);
                        } catch (e) {}
                    }

                    // Append full content to sammaryFullHtml
                    sammaryFullHtml += '<div><p>' + samary_value + '</p></div>';
                    sammaryhtml += samary_value+"\n";
                   
                }
            }
            // Handling option_response_item as key-value pairs
            var option_response_html = "";
            var suffixCounter = 0; // Reset suffix for each new 'i'
            var last_response_value = ""; // Ensure we track the last response value

            if (value.option_response_item && typeof value.option_response_item === 'object') {
                var responseKeys = Object.keys(value.option_response_item);
                var responseCount = responseKeys.length; // Get the count of responses

                for (var response_key in value.option_response_item) {
                    if (value.option_response_item.hasOwnProperty(response_key)) {
                        var response_value = value.option_response_item[response_key];
                        
                        // Remove any surrounding quotes from the response_value string
                        if (typeof response_value === 'string') {
                            response_value = response_value.replace(/^"(.*)"$/, '$1');
                        }

                        // Only add a new h3 if the current response_value is different from the last one
                        if (response_value !== last_response_value) {
                            var indexDisplay = i; // Base number

                            // If there are multiple responses, add the suffix (i, ii, etc.)
                            if (responseCount > 1) {
                                if (suffixCounter === 0) {
                                    // First item should show as the base index (e.g., '4')
                                    indexDisplay = i;
                                } else {
                                    // Subsequent items should use roman numerals (i, ii, etc.)
                                    var romanNumerals = ['(i)', '(ii)', '(iii)', '(iv)', '(v)', '(vi)', '(vii)', '(viii)', '(ix)', '(x)'];
                                    indexDisplay = romanNumerals[suffixCounter - 1] || suffixCounter; // Handle larger suffixes if needed
                                }
                            }

                            // Create the response title in the PDF
                            pdf.setFontSize(14).setFont("helvetica", "bold");
                            const titleLines = pdf.splitTextToSize(indexDisplay + " " + response_value, pageWidth);
                            titleLines.forEach(line => {
                                if (yOffset + 10 > pageHeight) {
                                    pdf.addPage();
                                    yOffset = 20;
                                }
                                pdf.text(line, margin, yOffset);
                                yOffset += 8;
                            });

                            last_response_value = response_value; // Update the last response value
                            suffixCounter++; // Increment the suffix counter for the next response
                        }
                    }
                }
            }
            // Append the summary below the response title
            pdf.setFontSize(12).setFont("helvetica", "normal");
            const summaryLines = pdf.splitTextToSize(sammaryhtml, pageWidth);
            summaryLines.forEach(line => {
                if (yOffset + 10 > pageHeight) {
                    pdf.addPage();
                    yOffset = 20;
                }
                pdf.text(line, margin, yOffset);
                yOffset += 8;
            });

            yOffset += 10; // Add extra spacing between responses
            i++; // Increment index after adding the first title with the index
        }
    }
    // Save the PDF with a name
    pdf.save("Theradome Hair Quiz Report.pdf");
});
/*PDF code end */

        }
    });

}

// View more/View less button click event
$(document).on('click', '.view-more-btn', function (e) {
    // Stop the click event from propagating to the accordion toggle
    e.stopPropagation();

    var fullContent = $(this).closest('.accordion-content').find('.summary-full');
    var shortContent = $(this).closest('.accordion-content').find('.summary-short');

    // Toggle full and short content
    fullContent.toggle();
    shortContent.toggle();

    // Toggle button text
    $(this).text(fullContent.is(":visible") ? "View less" : "View more");
});

// Accordion toggle logic
$(document).on('click', '.accordion-header', function () {
    var accordion = $(this).closest('.accordion');
    accordion.toggleClass('active');
    accordion.toggleClass('in-active');

    var accordionContent = accordion.find('.accordion-content');
    var accordionIcon = accordion.find('.accordion-icon');

    // Toggle accordion content visibility
    accordionContent.slideToggle();

    // Change accordion icon based on its state (active/inactive)
    if (accordion.hasClass('active')) {
        accordionIcon.css('background-image', 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/minus-icon-pq.png?v=1727102553)');
    } else {
        accordionIcon.css('background-image', 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/plus-icon-pq.png?v=1727102839)');
    }
});
       // Get all the accordion elements
   const accordions = document.getElementsByClassName('accordion');

   // Add click event listener to each accordion
   for (let i = 0; i < accordions.length; i++) {
      const accordion = accordions[i];
      const accordionContent = accordion.querySelector('.accordion-content');
      const accordionIcon = accordion.querySelector('.accordion-icon');

    if (i === 0) {
      accordion.classList.add('active');
      accordionContent.style.display = 'block';
      accordionIcon.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/minus-icon-pq.png?v=1727102553)';
    } else {
        accordion.classList.add('in-active');
      accordionContent.style.display = 'none';
      accordionIcon.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/plus-icon-pq.png?v=1727102839)';
    }
      accordion.addEventListener('click', function () {
         this.classList.toggle('active');

         if (accordionContent.style.display === 'block') {
            accordionContent.style.display = 'none';
            accordionIcon.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/plus.svg?v=1686302656)';
         } else {
            accordionContent.style.display = 'block';
            accordionIcon.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0721/6024/8100/files/minus-icon-pq.png?v=1727102553)';
         }
      });
   }


  } catch(e) { console.error(e); }
})();
})();
